/** Resolve server-relative paths to full URLs for previews in the admin panel. */
export function resolveAssetUrl(path) {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  const base = (process.env.REACT_APP_API_BASE_URL || "").replace(
    /\/api\/v1\/?$/i,
    ""
  );
  const clean = path.startsWith("/") ? path : `/${path}`;
  return base ? `${base}${clean}` : clean;
}

export function isImagePath(path) {
  if (!path) return false;
  return /\.(jpe?g|png|gif|webp)(\?|$)/i.test(path);
}
